import Vue from 'vue'

export default {
  setCurrentTimeline(state, timelineDays) {
    const days = (timelineDays && timelineDays.length > 0) ? timelineDays : []
    Vue.set(state, 'current', [...days])
  },
  appendCurrentTimeline(state, timelineDays) {
    const lastTimelineDay = state.current[state.current.length - 1]
    const firstTimelineDay = timelineDays[0]
    const remainderTimelineDays = timelineDays.splice(1)
    if (firstTimelineDay) {
      if (lastTimelineDay.date === firstTimelineDay.date) {
        // continuation of lastTimelineDay
        lastTimelineDay.events = lastTimelineDay.events.concat(firstTimelineDay.events)
        state.current = state.current.concat(remainderTimelineDays)
      } else {
        lastTimelineDay.events = lastTimelineDay.events.concat(firstTimelineDay.events)
        state.current.push(firstTimelineDay)
        state.current = state.current.concat(remainderTimelineDays)
      }
      Vue.set(state, 'current', [...state.current])
    }
  },
  setTimelineLoading(state, loading) {
    state.loading = loading
  },
  clearTimeline(state) {
    Vue.set(state, "current", [])
  },
  setCurrentTimelineType(state, currentType) {
    state.currentType = currentType
  },
  resetTimeline(state) {
    state.current = []
    state.currentType = null
    state.loading = false
  }
}
